import { graphql } from "../../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import {
  ManualPlanBonusInput,
  UnlimitedLessonPerWeekEnabledInput,
  UserClassRoomPlanWarrantyConfigInputDto,
} from "../../gql/graphql.ts";

const CreateClassRoomPlanMutation = graphql(`
  mutation createClassRoomPlan(
    $userId: String!
    $startedAtWeekUtc: String!
    $lessonsPerWeek: Int!
    $endedAtWeekUtc: String!
    $planToRecoverId: String
    $warrantyConfig: UserClassRoomPlanWarrantyConfigInputDto
    $unlimitedLessonPerWeek: UnlimitedLessonPerWeekEnabledInput
    $bonuses: [ManualPlanBonusInput!]
  ) {
    createClassRoomPlan(
      endedAtWeekUtc: $endedAtWeekUtc
      lessonsPerWeek: $lessonsPerWeek
      startedAtWeekUtc: $startedAtWeekUtc
      userId: $userId
      planToRecoverId: $planToRecoverId
      warrantyConfig: $warrantyConfig
      unlimitedLessonPerWeek: $unlimitedLessonPerWeek
      bonuses: $bonuses
    ) {
      ...ClassRoomPlanFragment
    }
  }
`);

export function useCreateClassRoomPlan() {
  const [createClassRoomPlanMutation, { loading }] = useMutation(
    CreateClassRoomPlanMutation,
  );

  const createClassRoomPlan = useCallback(
    async ({
      userId,
      startedAtWeekUtc,
      endedAtWeekUtc,
      lessonsPerWeek,
      planToRecoverId,
      warrantyConfig,
      unlimitedLessonPerWeek,
      bonuses,
    }: {
      userId: string;
      startedAtWeekUtc: string;
      lessonsPerWeek: number;
      endedAtWeekUtc: string;
      planToRecoverId?: string;
      warrantyConfig?: UserClassRoomPlanWarrantyConfigInputDto;
      unlimitedLessonPerWeek?: UnlimitedLessonPerWeekEnabledInput;
      bonuses?: ManualPlanBonusInput[];
    }) => {
      await createClassRoomPlanMutation({
        variables: {
          startedAtWeekUtc,
          lessonsPerWeek,
          endedAtWeekUtc,
          userId,
          planToRecoverId,
          warrantyConfig,
          unlimitedLessonPerWeek,
          bonuses,
        },
      });
    },
    [createClassRoomPlanMutation],
  );

  return {
    createClassRoomPlan,
    loading,
  };
}
